import { css } from '@emotion/react';

const makeCpcCardStyling = ({ iframeLoaded, showCpcRecommendations }) => {
  return {
    container: css({
      display: 'none',
      paddingLeft: '16px !important',
      paddingRight: '16px !important',
      ...(iframeLoaded &&
        showCpcRecommendations && {
          display: 'block',
        }),
    }),
    iframeContainer: css({
      display: 'flex',
      width: '100%',
    }),
    iframe: css({
      border: 'none',
      display: 'block',
      margin: '10px auto 0 auto',
      flexGrow: 1,
    }),
    grid: css({
      width: 0,
      ...(iframeLoaded &&
        showCpcRecommendations && {
          width: '100%',
        }),
    }),
  };
};

export default makeCpcCardStyling;
